import 'flag-icons/css/flag-icons.min.css';
import 'v-phone-input/styles';
import {
  createVPhoneInput,
  autocompletePhoneCountryInput,
  VPhoneCountryFlagSvg,
  guessPhoneCountry
} from 'v-phone-input';

export default function installVPhoneInput(app) {
  const vPhoneInput = createVPhoneInput({
    ...autocompletePhoneCountryInput,
    countryDisplayComponent: VPhoneCountryFlagSvg,
    guessCountry: guessPhoneCountry
  });
  app.use(vPhoneInput);
}
